module.exports = __webpack_public_path__ + "img/moom.0bac558d.jpg";